import { Button } from "../Control/Button/Button";
import EmailInput from "../Control/InputBox/EmailInput";
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';
import { useState } from "react";
import { addTimedNotification, showFailure } from "../NotificationStack/notificationSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { UserState } from "../../state/userSlice";

export type ForgotPasswordState = {
    email: string | null,
    isEmailValid: boolean
}

export function ForgotPassword() {
    const {
        isLoggedIn
    } = useSelector<RootState, UserState>(x => x.user);

    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState<ForgotPasswordState>({
        email: "",
        isEmailValid: true
    });

    const update = (updateFunc: (stateCopy: ForgotPasswordState) => void) => {
        const copy: ForgotPasswordState = JSON.parse(JSON.stringify(state));
        updateFunc(copy);
        setState(copy);
    }

    const reset = () => {
        if (!state.isEmailValid || !state.email) {
            return;
        }

        setIsLoading(true);
        sendPasswordResetEmail(auth, state.email)
            .then(() => {
                addTimedNotification({
                    message: "Password reset email sent!",
                    type: "success"
                }, 6000);
            })
            .catch((error) => {
                showFailure("Reset failed!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            <div className="flex min-h-full flex-1 flex-col justify-center sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-contrast-primary">
                        Forgot Password
                    </h2>
                </div>

                <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-[480px]">
                    <div className="bg-secondary px-6 py-12 shadow sm:rounded-lg">
                        <div className="space-y-6">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-contrast-primary">
                                    Email address
                                </label>
                                <div className="mt-2">
                                    <EmailInput
                                        showValidationErrors={true}
                                        onChange={(value, hasValidationErrors) => update((copy) => {
                                            copy.email = value;
                                            copy.isEmailValid = !hasValidationErrors;
                                        })}
                                        value={state.email} />
                                </div>
                            </div>

                            <div>
                                <Button
                                    color="emphasis"
                                    onClick={() => reset()}
                                    disabled={!state.isEmailValid || isLoading || isLoggedIn}
                                    className="w-full"
                                >
                                    Reset Password
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
